import {
  type QueryKey,
  keepPreviousData,
  useQuery,
} from '@tanstack/react-query';
import { Context, SearchType, gqlClient, graphql } from '@tyro/api';
import { useTranslation } from '@tyro/i18n';

const staffSearch = graphql(/* GraphQL */ `
  query staffSearchQuery($filter: SearchFilter) {
    search_search(filter: $filter) {
      partyId
      type
      text
      avatarUrl
    }
  }
`);

export function useStaffSearch(query: string, queryKey: QueryKey) {
  const { t } = useTranslation(['common']);
  const trimmedQuery = query.trim();

  return useQuery({
    queryKey,
    queryFn: async () =>
      gqlClient.request(staffSearch, {
        filter: {
          text: trimmedQuery,
          context: [Context.Party],
          includeSearchType: [
            SearchType.Staff,
            SearchType.GeneralGroup,
            SearchType.SubjectGroup,
            SearchType.YearGroupEnrollment,
            SearchType.CustomGroup,
          ],
        },
      }),
    enabled: trimmedQuery.length > 0,
    placeholderData: keepPreviousData,
    select: ({ search_search }) =>
      search_search.map((staff) => ({
        ...staff,
        firstName: staff.text,
        caption: staff.type ? t(`common:searchType.${staff.type}`) : '',
      })),
  });
}
